import { ConsultationDexieDb } from "../db/ConsultationDexieDb";
import { RecoveryCheckpoint } from "./types";

export class RecoveryCheckpointRepo {
  constructor(private readonly db: ConsultationDexieDb) {}

  async get(sessionId: string): Promise<RecoveryCheckpoint | undefined> {
    return this.db.recoveryCheckpoints.get(sessionId);
  }

  async upsert(checkpoint: RecoveryCheckpoint): Promise<void> {
    await this.db.recoveryCheckpoints.put(checkpoint);
  }
}
